import { deleteRequest } from '..';

const retireAsset = (assetId: string) => deleteRequest(`assets/v2/${assetId}`);

export default retireAsset;
